export default "__VITE_ASSET__5c5DQCx9__"